




import './KisweBadge.scss'
import { defineComponent } from '@vue/composition-api'
import { useThemes } from '../../compositions'

export default defineComponent({
  name: 'KisweBadge',
  props: {
    animation: {
      type: String as () => 'none'|'blink',
      default: 'none'
    },
    ...useThemes().props
  }
})
